// extracted by mini-css-extract-plugin
module.exports = {"from_franchise":"FromFranchise_from_franchise__rF6fA","from_franchise__link":"FromFranchise_from_franchise__link__nLxkb"};